import { useEffect, useMemo, useRef, useState, Fragment } from "react";
import { useRecoilState } from 'recoil';
import { namespaceState,selectedModelState,isModelDirScrollState } from '../../../recoil/atoms';
import * as d3 from "d3";
import styles from './BarChart.module.css'
import BarItem from "./BarItem";
import truncatText from '../../../utils/truncatText'
import ContextMenu from "../../../compoenets/ContextMenu";
import { useNavigate } from "react-router-dom";
import useApi from "../../../services/useApi";

// const MARGIN = { top: 30, right: 30, bottom: 30, left: 30 };
const MARGIN = { top: 0, right: 0, bottom: 0, left: 0 };
const BAR_PADDING = 0.3;

const BarWrap = ({data,
  sortedData,
  sortOrder,
  sortBy,
  d,
  index,
  boundsWidth,
  boundsHeight,
  labelWidth,
  onHover,
  onLeave,
  nowBarHover,
}) => {
  const [isBtnHover,setIsBtnHover]=useState(false);
  const [nsState,setNsState]=useRecoilState(namespaceState);
  const [selectedModel, setSelectedModel]=useRecoilState(selectedModelState);
  const [,setIsModelDirScroll]=useRecoilState(isModelDirScrollState);
  const userId=JSON.parse(localStorage.getItem("account")).id;

  const handleModelChange=(modelId)=>{
    useApi.get('/ngp/modelreg/mm/model/v1/model?modelId='+data.modelId+'&namespaceId='+nsState.id+'&userId='+userId)
    .then((res) => {
        // setIsModelDirScroll(true);
        setSelectedModel(res.data);
    })
  }
  const barGap=4;
    
  const groups = sortedData.map((d)=>d.taskName);
  const yScale = useMemo(() => {
    return d3
      .scaleBand()
      .domain(groups)
      .range([0, boundsHeight])
      .padding(BAR_PADDING)
  }, [data, boundsHeight])

  const yPos=yScale(d.taskName);
  const barHeight=yScale.bandwidth()/2;
    
  const maxAcc=d3.max(sortedData,(d)=>d.accuracy);
  const minAcc=d3.min(sortedData,(d)=>d.accuracy);
  const maxLoss=d3.max(sortedData,(d)=>d.loss);
  const minLoss=d3.min(sortedData,(d)=>d.loss);

  const xScaleAcc = d3
    .scaleLog()
    .domain([minAcc-minAcc*.8, maxAcc])
    .range([0, boundsWidth])

  const xScaleLoss = d3
    .scaleLog()
    .domain([minLoss-minLoss*.8, maxLoss])
    .range([0, boundsWidth])

  const navigate = useNavigate();
  const handleNavigation = () => {
    if (!document.startViewTransition) {
      return navigate('/task-detail/'+data.taskId);
    } else {
      return document.startViewTransition(() => {
        navigate('/task-detail/'+data.taskId);
      });
    }
  };
 
  return (
    <Fragment key={d.taskName}>
      <ContextMenu
      useBounding={false}
      menuShow={true}
      renderBtn={({ref, onClick})=>(
      <g
      ref={ref}
      onMouseEnter={()=>setIsBtnHover(true)}
      onMouseLeave={()=>setIsBtnHover(false)}
      onClick={onClick}
      className={styles['barWrap']}
      >
        <rect
          x={-7}
          y={yPos - 7}
          width="calc(100% + 14px)"
          height={barHeight*2+barGap+14}
          stroke={isBtnHover?"#eee":"#f4f5fb00"}
          fill={isBtnHover?"#f4f5fb":"#f4f5fb00"}
          rx={8}
          strokeWidth={1.5}
          className={styles['barAcc']}
          
        />
        <text
          width={labelWidth}
          x={0}
          y={yPos+barHeight+4}
          textAnchor="start"
          alignmentBaseline="middle"
          fontSize={14}
          fill="#181818"
          fontWeight="bold"
        >
            {truncatText(d.taskName,12)}
        </text>
        <BarItem
          // key={d.taskId}
          name="Acc"
          value={d.accuracy}
          barHeight={barHeight}
          barWidth={xScaleAcc(d.accuracy)}
          // radius={10}
          x={labelWidth}
          y={sortBy==='loss'?yPos+barHeight+barGap:yPos}
          fill={sortBy==='loss'?"#181818":"#205BF1"}
          stroke={sortBy==='loss'?"#181818":"#205BF1"}
          onHover={()=>onHover("acc")}
          onLeave={onLeave}
          opacity={nowBarHover==='loss'&&.2}
        />
        <BarItem
          // key={d.taskId}
          name="Loss"
          value={d.loss}
          barHeight={barHeight}
          barWidth={xScaleLoss(d.loss)}
          // radius={7}
          x={labelWidth}
          y={sortBy==='loss'?yPos:yPos+barHeight+barGap}
          fill={sortBy==='loss'?"#205BF1":"#181818"}
          stroke={sortBy==='loss'?"#205BF1":"#181818"}
          onHover={()=>onHover("loss")}
          onLeave={onLeave}
          opacity={nowBarHover==='acc'&&.2}
        />
      </g>
    )} 
    renderMenu={()=>(
        <>
          <span 
          className={styles['context-item']} 
          onClick={handleNavigation}>
            Task Detail
          </span>
          <span 
          className={styles['context-item']}
          onClick={handleModelChange}>
            Model Detail
          </span>
        </>
    )} 
    />
    </Fragment>
  )
}

export default function BarChart({
  data,
  sortBy='accuracy',
  sortOrder='desc',
  onHover,
  onLeave,
  nowBarHover
}){
  const wrapRef=useRef(null);
  const [wrapWidth,setWrapWidth]=useState(0);
  const [wrapHeight,setWrapHeight]=useState(0);

  // const [sortedData,setSortedData]=useState(data);

  const sortedData=useMemo(()=>{
    return data;
  },[data,sortBy,sortOrder])

  // const sortedData=useMemo(()=>{
  //   return [...data].sort((a,b)=>{
  //     const compareValue=sortOrder==='asc'?1:-1;
  //     return (a[sortBy] - b[sortBy])*compareValue;
  //   });
  // },[data,sortBy,sortOrder])

  // const [boundsWidth,setBoundsWidth]=useState(0);
  // const [boundsHeight,setBoundsHeight]=useState(0);

  useEffect(()=>{
    const resizeObserver=new ResizeObserver((entries)=>{
      for(let entry of entries){
        if(entry.target && document.body.contains(entry.target)){
          const {width,height}=wrapRef.current.getBoundingClientRect();
          setWrapWidth(width);
          setWrapHeight(height);
          // setBoundsWidth(width - MARGIN.right - MARGIN.left)
          // setBoundsHeight(height - MARGIN.top - MARGIN.bottom)
        }
      }
    })

    if(wrapRef.current){
      resizeObserver.observe(wrapRef.current)
    }

    return()=>{
      if(wrapRef.current){
        resizeObserver.unobserve(wrapRef.current);
      }
      resizeObserver.disconnect();
    }
  },[])

  const labelWidth = (wrapWidth - MARGIN.right - MARGIN.left) * .2;
  const boundsWidth = wrapWidth - labelWidth;
  const boundsHeight = wrapHeight - MARGIN.top - MARGIN.bottom;

  return (
    <div ref={wrapRef} className={styles['wrap']}>
      <svg 
      width='100%' 
      height='100%'
      className={styles['svg']}
      >
        <g
          width={boundsWidth}
          height={boundsHeight}
          transform={`translate(${[MARGIN.left, MARGIN.top].join(",")})`}
        >
          {sortedData.map((d,index)=>
          <BarWrap
          data={d}
          sortedData={sortedData}
          sortOrder={sortOrder}
          sortBy={sortBy}
          boundsWidth={boundsWidth}
          boundsHeight={boundsHeight}
          labelWidth={labelWidth}
          d={d}
          index={index}
          onHover={onHover}
          onLeave={onLeave}
          nowBarHover={nowBarHover}
          />
          )}
        </g>
      </svg>
    </div>
  )
};
